import React from 'react';
import PropTypes from 'prop-types';
// import Optawidget from 'components_v2/common/Optawidget';
// import classNames from 'classnames';
import { gaWrapper } from 'helpers/analytics';
import { inlineOptaList } from '../../../../liveblog_v2/utils/TabConstants';
import s from './OptaWidgetInLine.scss';

class OptaWidgetInLine extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cricketActiveTabObject: {
        name: 'match_action',
      },
    };
  }

  loadNewOptaWidgets = item => {
    const conId = `inlineContainer-${item.name}`;
    const mainContainer = document.getElementById(conId);
    if (
      typeof mainContainer === 'object' &&
      mainContainer !== null &&
      typeof Opta !== 'undefined'
    ) {
      const optaWidgetTags = mainContainer.getElementsByTagName('opta-widget');
      let unloadedWidget = false;
      if (optaWidgetTags && optaWidgetTags.length > 0) {
        for (let i = 0; i < optaWidgetTags.length; i += 1) {
          if (optaWidgetTags[i].getAttribute('load') === 'false') {
            unloadedWidget = true;
            optaWidgetTags[i].removeAttribute('load');
          }
        }
        if (unloadedWidget === true) {
          // eslint-disable-next-line no-undef
          Opta.start();
        }
      }
    }
  };

  resumeFocusedOptaWidgets = () => {
    if (typeof Opta !== 'undefined') {
      const widgetContainers = document.getElementsByClassName('Opta');
      if (widgetContainers && widgetContainers.length > 0) {
        for (let i = 0; i < widgetContainers.length; i += 1) {
          if (
            typeof widgetContainers[i] !== 'undefined' &&
            widgetContainers[i] !== null
          ) {
            const widgetId = widgetContainers[i].getAttribute('id');
            // eslint-disable-next-line no-undef
            const Widget = Opta.widgets[widgetId];
            Widget.resume(Widget.live, Widget.first_time);
          }
        }
      }
    }
  };

  pauseHiddenOptaWidgets = () => {
    if (typeof Opta !== 'undefined') {
      const widgetContainers = document.getElementsByClassName('Opta');
      if (widgetContainers.length > 0) {
        for (let i = 0; i < widgetContainers.length; i += 1) {
          const widgetId = widgetContainers[i].getAttribute('id');
          // eslint-disable-next-line no-undef
          const Widget = Opta.widgets[widgetId];
          Widget.pause();
        }
      }
    }
  };

  changeCricketTabs = (item, event) => {
    this.setState({ cricketActiveTabObject: item }, () => {
      if (event && typeof event !== 'undefined') {
        gaWrapper(
          'send',
          'event',
          this.props.gaCategory,
          `${item.itemgaPrefix}_Click`,
          `Click-${item.gaLabel}`,
        );
      }
      if (item && item.type === 'optaWidget') {
        this.loadNewOptaWidgets(item);
        this.pauseHiddenOptaWidgets();
        this.resumeFocusedOptaWidgets();
      }
    });
  };

  inlineTabClickHandler = (event, item) => {
    // const { currentTarget } = event;
    this.changeCricketTabs(item, event);
  };

  setDefaultActiveTab = () => {
    let activeOptaIndex = 0;
    const { matchStatus } = this.props;
    if (
      matchStatus &&
      matchStatus.matchStatus &&
      matchStatus.matchStatus.toLowerCase() === 'match ended'
    ) {
      // activeOptaIndex = 2;
      activeOptaIndex = undefined; // TOIPR-65769 : remove opta when match over
    } else if (
      matchStatus &&
      matchStatus.currentInning &&
      matchStatus.currentInning.toLowerCase() === 'second'
    ) {
      activeOptaIndex = 1;
    }

    const activeInlineOptaTab = inlineOptaList[activeOptaIndex];
    if (typeof Opta !== 'undefined') {
      this.changeCricketTabs(activeInlineOptaTab);
    } else {
      setTimeout(() => {
        this.setDefaultActiveTab();
      }, 1000);
    }
  };

  componentDidMount() {
    this.setDefaultActiveTab();
    this.props.onOptaWidgetInlineLoad(this.setDefaultActiveTab);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.matchStatus.matchStatus !==
        this.props.matchStatus.matchStatus ||
      prevProps.matchStatus.currentInning !==
        this.props.matchStatus.currentInning
    ) {
      this.setDefaultActiveTab();
    }
  }

  render() {
    const gaData = `OptaCarousel_Seen`;
    const { cricketActiveTabObject } = this.state;
    const { children: OptaWidget } = this.props;
    return (
      <div data-scrollga={gaData}>
        {this.props.displayTabs && (
          <div className={s.optatabs}>
            <h5>Match Stats</h5>
            <ul>
              {inlineOptaList.map((citem, index) => (
                <li
                  key={index}
                  onClick={event => this.inlineTabClickHandler(event, citem)}
                >
                  <button
                    className={
                      cricketActiveTabObject &&
                      cricketActiveTabObject.name === citem.name
                        ? `${s.active}`
                        : ``
                    }
                  >
                    {citem.displayName}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
        {inlineOptaList.map(citem => (
          <div
            id={`inlineContainer-${citem.name}`}
            name={citem.name}
            className={
              cricketActiveTabObject &&
              cricketActiveTabObject.name !== citem.name
                ? s.hideTimeline
                : ''
            }
          >
            {OptaWidget({
              widgetName: citem.name,
              competition: this.props.competition,
              season: this.props.season,
              match: this.props.match,
              autoload: citem.autoload,
            })}
            {/* <OptaWidget
              widgetName={citem.name}
              competition={this.props.competition}
              season={this.props.season}
              match={this.props.match}
              autoload={citem.autoload}
            /> */}
          </div>
        ))}
      </div>
    );
  }
}

OptaWidgetInLine.propTypes = {
  competition: PropTypes.string,
  displayTabs: PropTypes.string,
  season: PropTypes.string,
  match: PropTypes.string,
  gaCategory: PropTypes.string,
  // isWapView: PropTypes.bool,
  matchStatus: PropTypes.shape({
    matchStatus: PropTypes.string,
    currentInning: PropTypes.string,
  }),
  onOptaWidgetInlineLoad: PropTypes.func,
  children: PropTypes.func,
};

OptaWidgetInLine.defaultProps = {
  competition: '',
  displayTabs: true,
  season: '',
  match: '',
  gaCategory: '',
  // isWapView: false,
  matchStatus: {},
  onOptaWidgetInlineLoad: () => {},
  children: () => null,
};

export default OptaWidgetInLine;
